module.exports = __webpack_public_path__ + "static/img/onlineBanner.75b25347.jpg";